export default "__VITE_ASSET__C6Uzef4y__"